// ui/mui/core/src/StepLabel.tsx
import { StepLabel as MUIStepLabel, StepLabelProps } from '@mui/material';
export const StepLabel = (props: StepLabelProps) => (
  <MUIStepLabel data-testid="stepLabel" {...props} />
);
